import script from "./GlobalFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalFooter.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalFooter.vue?vue&type=style&index=0&id=fc07dc48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc07dc48"]])

export default __exports__